import {CHANGES_LOG} from '../actions/ChangesLog';

const initialState = {
    changes: [],
};


const ChangesLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGES_LOG:
            return {
                changes: action.payload.changes
            };
        default:
            return state
    }
};


export default ChangesLogReducer;